<template>
  <div class="flex flex-wrap mb-2">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6">
      <div>
        <span class="text-grap-700 align-middle">高效速成 + AutoTurn AI Test</span>
        <i
          class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
          v-tooltip.top="'啟用後，系統將以「高效速成+ vs 原始受眾策略」進行A/B 測試，並自動分配預算、分析成效，最終將預算集中至表現最佳的投放方式。'"
        ></i>
      </div>
      <div class="flex-1 space-y-4">
        <div>
          <div class="flex items-center space-x-4">
            <div class="mt-2">
              <InputSwitch :disabled="editPageType" v-model="viewDatalistData.advantage_ab_test"/>
            </div>
            <div class="text-sm leading-6 text-gray-400">啟用A/B Test</div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
</template>

<script>
import InputSwitch from 'primevue/inputswitch';

export default {
  name: 'AdvantageAbTest',
  components: {
    InputSwitch,
  },
  props: {
    editPage: {
      type: Boolean,
      default: false,
    },
    viewDatalist: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage;
      },
      set: function (value) {
        this.$emit('update:editPageType', value);
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist;
      },
      set: function (value) {
        this.$emit('update:viewDatalist', value);
      },
    },
  },
}
</script>
